// extracted by mini-css-extract-plugin
export default {"footer_container":"Footer_footer_container__Ktney","footer_item":"Footer_footer_item__sJzQq","footer_item_end":"Footer_footer_item_end__0jzTw","item":"Footer_item__RbUtf"};